/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TableBody,
  Divider,
  Alert,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import SelectInput from "../../../form-fields/select-input";
import DashBoardContainer from "../../../layout/dashboard-container";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import DateInput from "../../../form-fields/date-picker";
import { useFormik, FormikProvider, Form } from "formik";
import FormButtons from "../buttons";
import { getUserZoneList } from "../../../../services/view-challan-service";
import { useReactToPrint } from "react-to-print";
import { Print } from "@mui/icons-material";
import "./viewChallanStyle.css";
import { chequeDdChallanResult } from "../../../../services/view-challan-service";
import { useNavigate } from "react-router-dom";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import useApiState from "../../common/useApiState";
import {
  getCurrentDate,
  getErrorMsg,
  isEmptyObj,
} from "../../../../utils/helpers";
import { showToastError, showToastSuccess } from "../../../common/toastHelper";
import { viewChalanSchema } from "../../../../utils/validation-schema";

const ViewChallan = () => {
  const navigate = useNavigate();
  const initialState = {
    zoneName: "",
    modeOfPayment: "",
    counterName: "",
    receiptDate: getCurrentDate(),
  };

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: viewChalanSchema,
  });

  const [zoneList, setZoneList] = useState([]);
  const { loading, setLoading, error, setError } = useApiState();

  useEffect(() => {
    //window.localStorage.removeItem("CashChallanInput");

    const fetchData = async () => {
      const zoneListRes = await getUserZoneList();

      const zoneList = zoneListRes.map((record) => ({
        value: record.zonename,
        label: record.zonename,
      }));
      setZoneList(zoneList);
    };

    fetchData();
  }, []); // Empty dependency array ensures it runs only once

  const lang = useSelector((state) => state.userDetails.lang);
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const [modeOfPayemntTypes, setModeOfPayemntTypes] = useState([
    { value: "Cheque", label: "Cheque" },
    { value: "DD", label: "DD" },
    { value: "Cash", label: "Cash" },
  ]);
  const [counterTypes, setCounterTypes] = useState([
    { value: "COUNTER1", label: "Counter 1" },
  ]);

  const [challanData, setChallanData] = useState("");

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
    formik.setTouched({
      zoneName: true,
      modeOfPayment: true,
      counterName: true,
      receiptDate: true,
    });
    await formik.validateForm();
    if (isEmptyObj(formik.errors)) {
      if (
        formik.values.zoneName &&
        formik.values.modeOfPayment &&
        formik.values.counterName &&
        formik.values.receiptDate
      ) {
        if (formik.values.modeOfPayment === "Cash") {
          window.localStorage.setItem(
            "CashChallanInput",
            JSON.stringify(formik.values)
          );
          navigate("/CashChallan");
        } else {
          try {
            setLoading(true);
            const response = await chequeDdChallanResult(formik.values);
            setChallanData(response);
            showToastSuccess();
          } catch (error) {
            showToastError(getErrorMsg(error));
          } finally {
            setLoading(false);
          }
        }
      }
    }
  };

  return (
    <DashBoardContainer>
      <FormikProvider value={formik}>
        <Form>
          {loading && <Loader />}
          {error && (
            <AlertMsg
              message={error}
              severity="error"
              onClose={() => {
                setError("");
              }}
            />
          )}
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.ViewChallan[lang]} />
            <Grid>
              <GridRow>
                <FormLabel label={labels.Vibhag[lang]} />
                <FormValue
                  component={
                    <SelectInput name="zoneName" options={zoneList} required />
                  }
                />
                <FormLabel label={labels.PaymentMode[lang]} />
                <FormValue
                  component={
                    <SelectInput
                      name="modeOfPayment"
                      options={modeOfPayemntTypes}
                      required
                    />
                  }
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.Counter[lang]} />
                <FormValue
                  component={
                    <SelectInput
                      name="counterName"
                      options={counterTypes}
                      required
                    />
                  }
                />
                <FormLabel label={labels.Date[lang]} />
                <FormValue
                  component={<DateInput name="receiptDate" required />}
                />
              </GridRow>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    // isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmitButtonClick}
                    resetForm={() => {
                      formik.resetForm();
                    }}
                    submitBtnLabel="Show"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          {challanData ? (
            <>
              <div className="counter-div">
                <Button
                  onClick={handlePrint}
                  variant="contained"
                  startIcon={<Print />}
                >
                  Print
                </Button>
              </div>
              <Grid ref={printRef}>
                <GridRow>
                  <Grid container justifyContent="center">
                    <Grid
                      sx={{
                        textAlign: "center", // Centers the text horizontally
                        fontWeight: "bold", // Ensures the text is bold
                      }}
                    >
                      <b>
                        पिंपरी चिंचवड महानगरपालिका,पिंपरी - ४११०१८
                        <br />
                        कर संकलन विभाग
                        <br />
                        चलन तपशील
                      </b>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    sx={{ width: "85%", marginLeft: "110px" }}
                  >
                    <Grid item xs={12} sm={6} md={6}>
                      <div>{labels.Zone[lang]} - {challanData.zoneName}</div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                      <div>{labels.Counter[lang]} - {formik.values.counterName}</div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                      <div>चलन दिनांक - {challanData.receiptDate}</div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                      <div>देयक प्रकार - {challanData.modeOfPayment}</div>
                    </Grid>
                  </Grid>

                  <TableContainer>
                    <Table
                      size="small"
                      sx={{
                        minWidth: 450,
                        border: "2px solid black",
                        width: "85%",
                        margin: "auto",
                        marginTop: "10px",
                      }}
                      aria-label="simple table"
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          >
                            {labels.Zone[lang]}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          >
                            {challanData.zoneName}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          >
                            {labels.UserName[lang]}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          >
                            {challanData.userName}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          >
                            {labels.ChallanDate[lang]}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          >
                            {challanData.receiptDate}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          >
                            {labels.PaymentMode[lang]}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          >
                            {challanData.modeOfPayment}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          >
                            {labels.AccountNo[lang]}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          ></TableCell>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          >
                            {labels.BankName[lang]}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          >
                            {challanData.bankName}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          >
                            {labels.Amount[lang]}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          >
                            {challanData.lblTotalAmt}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ border: "1px solid black" }}
                          ></TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid black" }}
                          ></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </GridRow>
                <Divider sx={{ marginTop: "30px", marginBottom: "30px" }} />
                <div className="tableTitle">{labels.BillReceipt[lang]}</div>
                <GridRow>
                  <TableContainer>
                    <Table
                      size="small"
                      sx={{
                        minWidth: 550,
                        border: "2px solid black",
                        width: "85%",
                        margin: "auto",
                      }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow
                          sx={{
                            background: "#e6eaeb",
                            "&:last-child td, &:last-child th": {
                              border: "1px solid black",
                            },
                          }}
                        >
                          <TableCell align="center">
                            {labels.SrNoShort[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ChequeDDDate[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ChequeDDNumber[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.BankName[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ChequeDDAmount[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ReceiptCount[lang]}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {challanData?.lstChequeForReceipt?.length > 0 ? (
                          challanData.lstChequeForReceipt.map((item, index) => (
                            <TableRow>
                              <TableCell align="center" className="cellBorder">
                                {index + 1}
                              </TableCell>
                              <TableCell align="center" className="cellBorder">
                                {item.chequeDate}
                              </TableCell>
                              <TableCell align="center" className="cellBorder">
                                {item.chequeNumber}
                              </TableCell>
                              <TableCell align="center" className="cellBorder">
                                {item.bankName}
                              </TableCell>
                              <TableCell align="center" className="cellBorder">
                                {item.txtPaidAmount}
                              </TableCell>
                              <TableCell align="center" className="cellBorder">
                                {item.receiptCount}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              माहिती उपलब्ध नाही
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </GridRow>
                <div className="tableTitle">
                  {labels.PerfilledBillReceipt[lang]}
                </div>
                <GridRow>
                  <TableContainer>
                    <Table
                      size="small"
                      sx={{
                        minWidth: 550,
                        border: "2px solid black",
                        width: "85%",
                        margin: "auto",
                      }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow
                          sx={{
                            background: "#e6eaeb",
                            "&:last-child td, &:last-child th": {
                              border: "1px solid black",
                            },
                          }}
                        >
                          <TableCell align="center">
                            {labels.SrNoShort[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ChequeDDDate[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ChequeDDNumber[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.BankName[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ChequeDDAmount[lang]}
                          </TableCell>
                          <TableCell align="center">
                            {labels.ReceiptCount[lang]}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {challanData?.lstChequeForPrefilledReceipt?.length >
                        0 ? (
                          challanData.lstChequeForPrefilledReceipt.map(
                            (row, index) => (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                >
                                  {row.chequeDate}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                >
                                  {row.chequeNumber}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                >
                                  {row.bankName}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                >
                                  {row.txtPaidAmount}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                >
                                  {row.receiptCount}
                                </TableCell>
                              </TableRow>
                            )
                          )
                        ) : (
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              माहिती उपलब्ध नाही
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </GridRow>
              </Grid>
            </>
          ) : (
            <Grid>
              <GridRow
                sx={{
                  justifyContent: "center",
                }}
              >
                <Alert
                  severity="info"
                  sx={{
                    margin: "5px",
                    justifyContent: "center",
                  }}
                >
                  Please select all parameters to view challan
                </Alert>
              </GridRow>
            </Grid>
          )}
        </Form>
      </FormikProvider>
    </DashBoardContainer>
  );
};

export default ViewChallan;
